import React from "react";
import { Link } from "react-router-dom";
import { Navbar, Nav } from "react-bootstrap";
import "../style/nav.css";

function Navigation() {
  return (
    <Navbar bg="light" expand="lg">
      <Navbar.Brand as={Link} to="/">
      <svg
            width="60"
            height="40"
            viewBox="0 0 522 521"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_d)">
              <path
                d="M416 240H96V104L152 72H360L416 104V240Z"
                fill="#AABECE"
              />
              <path d="M320 144H192L200 24H312L320 144Z" fill="#394D5C" />
              <path
                d="M256 72C269.255 72 280 61.2548 280 48C280 34.7452 269.255 24 256 24C242.745 24 232 34.7452 232 48C232 61.2548 242.745 72 256 72Z"
                fill="#F4F4E6"
              />
              <path
                d="M96 296L176 312L256 296L336 312L416 296V240H96V296Z"
                fill="#B5554E"
              />
              <path d="M416 144H96V240H416V144Z" fill="#2D75BB" />
              <path
                d="M224 272L184 280L144 272L128 240H240L224 272Z"
                fill="#FFD782"
              />
              <path
                d="M368 272L328 280L288 272L272 240H384L368 272Z"
                fill="#FFD782"
              />
              <path
                d="M176 312V424L224 456L232 488H280L288 456L336 424V312L256 296L176 312Z"
                fill="#F4F4E6"
              />
              <path
                d="M280 488H232L224 456L232 400L256 392L280 400L288 456L280 488Z"
                fill="#394D5C"
              />
              <path
                d="M294.432 343.84L256 336.16L217.568 343.84L214.432 328.16L256 319.84L297.568 328.16L294.432 343.84Z"
                fill="#394D5C"
              />
              <path
                d="M294.432 375.84L256 368.16L217.568 375.84L214.432 360.16L256 351.84L297.568 360.16L294.432 375.84Z"
                fill="#394D5C"
              />
              <path d="M176 464L144 472V304.888L176 312V464Z" fill="#DD3E46" />
              <path d="M144 472L96 488V296L144 304.888V472Z" fill="#7D8D9C" />
              <path
                d="M296 192L256 208L216 192L224 104H288L296 192Z"
                fill="#F4F4E6"
              />
              <path d="M96 440H32V216L96 184V440Z" fill="#AABECE" />
              <path d="M96 248H64V280H96V248Z" fill="#394D5C" />
              <path d="M96 312H64V344H96V312Z" fill="#394D5C" />
              <path d="M96 376H64V408H96V376Z" fill="#394D5C" />
              <path d="M336 464L368 472V304.888L336 312V464Z" fill="#DD3E46" />
              <path d="M368 472L416 488V296L368 304.888V472Z" fill="#7D8D9C" />
              <path d="M416 440H480V216L416 184V440Z" fill="#AABECE" />
              <path d="M416 280H448V248H416V280Z" fill="#394D5C" />
              <path d="M416 344H448V312H416V344Z" fill="#394D5C" />
              <path d="M416 408H448V376H416V408Z" fill="#394D5C" />
              <path d="M296 192L488 24L288 104L296 192Z" fill="#DD3E46" />
              <path d="M216 192L24 24L224 104L216 192Z" fill="#DD3E46" />
              <path
                d="M216 192L256 208L296 192L291.64 144L256 160L220.36 144L216 192Z"
                fill="#FFD782"
              />
              <path
                d="M144 208C152.837 208 160 200.837 160 192C160 183.163 152.837 176 144 176C135.163 176 128 183.163 128 192C128 200.837 135.163 208 144 208Z"
                fill="#F4F4E6"
              />
              <path
                d="M368 208C376.837 208 384 200.837 384 192C384 183.163 376.837 176 368 176C359.163 176 352 183.163 352 192C352 200.837 359.163 208 368 208Z"
                fill="#F4F4E6"
              />
              <path
                d="M214.432 328.16L217.568 343.84L256 336.16L294.432 343.84L297.568 328.16L256 319.84L214.432 328.16Z"
                fill="black"
              />
              <path
                d="M214.432 360.16L217.568 375.84L256 368.16L294.432 375.84L297.568 360.16L256 351.84L214.432 360.16Z"
                fill="black"
              />
              <path
                d="M485.032 16.5679L363.912 65.0159L362.168 63.9999H322.68L320 23.4719C319.866 21.443 318.964 19.5413 317.478 18.1534C315.992 16.7655 314.033 15.9955 312 15.9999H200C197.967 15.9955 196.008 16.7655 194.522 18.1534C193.036 19.5413 192.134 21.443 192 23.4719L189.32 63.9999H149.832L148.088 65.0159L26.968 16.5679C25.2138 15.8655 23.2676 15.8067 21.4742 16.4019C19.6808 16.9971 18.156 18.2079 17.1698 19.8197C16.1837 21.4316 15.8 23.3405 16.0867 25.2083C16.3734 27.076 17.3119 28.782 18.736 30.0239L94.032 95.9119L88 99.3599V179.056L24 211.056V448H88V488C88 490.122 88.8429 492.156 90.3431 493.657C91.8434 495.157 93.8783 496 96 496C96.8597 496 97.7137 495.86 98.528 495.584L146.248 479.68L177.936 471.76C179.667 471.328 181.205 470.33 182.304 468.924C183.402 467.518 184 465.784 184 464V438.944L216.984 460.936L225.752 496H286.248L295.048 460.936L328 438.944V464C328 465.784 328.598 467.518 329.696 468.924C330.795 470.33 332.333 471.328 334.064 471.76L365.752 479.68L413.472 495.584C414.286 495.86 415.14 496 416 496C418.122 496 420.157 495.157 421.657 493.657C423.157 492.156 424 490.122 424 488V448H488V211.056L424 179.056V99.3599L417.968 95.9119L493.264 30.0239C494.688 28.782 495.627 27.076 495.913 25.2083C496.2 23.3405 495.816 21.4316 494.83 19.8197C493.844 18.2079 492.319 16.9971 490.526 16.4019C488.732 15.8067 486.786 15.8655 485.032 16.5679ZM272 47.9999C272 51.1644 271.062 54.2579 269.304 56.889C267.545 59.5202 265.047 61.571 262.123 62.782C259.199 63.993 255.982 64.3099 252.879 63.6925C249.775 63.0751 246.924 61.5513 244.686 59.3136C242.449 57.076 240.925 54.2251 240.307 51.1214C239.69 48.0177 240.007 44.8006 241.218 41.877C242.429 38.9534 244.48 36.4545 247.111 34.6964C249.742 32.9383 252.835 31.9999 256 31.9999C260.243 31.9999 264.313 33.6856 267.314 36.6862C270.314 39.6868 272 43.7565 272 47.9999ZM228.448 31.9999C225.569 36.8427 224.033 42.3659 224 47.9999C224 56.4869 227.371 64.6262 233.373 70.6273C239.374 76.6285 247.513 79.9999 256 79.9999C264.487 79.9999 272.626 76.6285 278.627 70.6273C284.629 64.6262 288 56.4869 288 47.9999C287.967 42.3659 286.431 36.8427 283.552 31.9999H304.512L308.192 87.3039L286.456 95.9999H225.544L203.808 87.3039L207.488 31.9999H228.448ZM280.696 112L283.152 139.04L256 151.2L228.848 139.04L231.304 112H280.696ZM227.32 155.888L252.728 167.296C253.757 167.757 254.872 167.996 256 167.996C257.128 167.996 258.243 167.757 259.272 167.296L284.68 155.888L287.488 186.792L256 199.384L224.512 186.792L227.32 155.888ZM215.488 109.208L209.456 175.608L64.512 48.7999L215.488 109.208ZM104 108.64L106.776 107.04L139.848 136H104V108.64ZM40 432V220.944L88 196.944V240H56V288H88V304H56V352H88V368H56V416H88V432H40ZM138.592 279.08L184 288.16L229.408 279.08L244.944 248H267.056L282.592 279.08L328 288.16L373.408 279.08L388.944 248H408V289.344L366.544 297.024L366.264 297.08L335.864 303.824L256 287.84L176.096 303.84L145.696 297.096L145.416 297.04L104 289.344V248H123.056L138.592 279.08ZM140.944 248H227.056L218.592 264.92L184 271.84L149.408 264.92L140.944 248ZM284.944 248H371.056L362.592 264.92L328 271.84L293.408 264.92L284.944 248ZM424 256H440V272H424V256ZM424 320H440V336H424V320ZM88 272H72V256H88V272ZM88 336H72V320H88V336ZM88 400H72V384H88V400ZM104 305.752L136 312.152V466.232L104 476.896V305.752ZM168 457.752L152 461.752V315.352L168 318.552V457.752ZM238.248 480L232.144 455.576L239.216 406.024L256.016 400.424L272.816 406.024L279.888 455.576L273.752 480H238.248ZM294.128 442.304L287.2 393.976L256 383.576L224.8 393.976L217.888 442.304L184 419.72V318.56L256 304.16L328 318.56V419.72L294.128 442.304ZM344 318.56L360 315.36V461.76L344 457.76V318.56ZM408 476.896L376 466.232V312.152L408 305.752V476.896ZM424 384H440V400H424V384ZM472 220.944V432H424V416H456V368H424V352H456V304H424V288H456V240H424V196.944L472 220.944ZM408 232H104V152H158.136L210.736 198.024H210.776C211.445 198.609 212.207 199.077 213.032 199.408L253.032 215.408C254.937 216.169 257.063 216.169 258.968 215.408L298.968 199.408C299.793 199.077 300.555 198.609 301.224 198.024H301.264L353.864 152H408V232ZM408 108.64V136H372.152L405.224 107.056L408 108.64ZM302.544 175.64L296.512 109.24L447.488 48.7999L302.544 175.64Z"
                fill="black"
              />
              <path
                d="M144 168C139.253 168 134.613 169.408 130.666 172.045C126.72 174.682 123.643 178.43 121.827 182.816C120.01 187.201 119.535 192.027 120.461 196.682C121.387 201.338 123.673 205.614 127.029 208.971C130.386 212.327 134.662 214.613 139.318 215.539C143.973 216.465 148.799 215.99 153.184 214.173C157.57 212.357 161.318 209.28 163.955 205.334C166.592 201.387 168 196.747 168 192C168 185.635 165.471 179.53 160.971 175.029C156.47 170.529 150.365 168 144 168ZM144 200C142.418 200 140.871 199.531 139.555 198.652C138.24 197.773 137.214 196.523 136.609 195.061C136.003 193.6 135.845 191.991 136.154 190.439C136.462 188.887 137.224 187.462 138.343 186.343C139.462 185.224 140.887 184.462 142.439 184.154C143.991 183.845 145.6 184.003 147.061 184.609C148.523 185.214 149.773 186.24 150.652 187.555C151.531 188.871 152 190.418 152 192C152 194.122 151.157 196.157 149.657 197.657C148.157 199.157 146.122 200 144 200Z"
                fill="black"
              />
              <path
                d="M368 168C363.253 168 358.613 169.408 354.666 172.045C350.72 174.682 347.643 178.43 345.827 182.816C344.01 187.201 343.535 192.027 344.461 196.682C345.387 201.338 347.673 205.614 351.029 208.971C354.386 212.327 358.662 214.613 363.318 215.539C367.973 216.465 372.799 215.99 377.184 214.173C381.57 212.357 385.318 209.28 387.955 205.334C390.592 201.387 392 196.747 392 192C392 185.635 389.471 179.53 384.971 175.029C380.47 170.529 374.365 168 368 168ZM368 200C366.418 200 364.871 199.531 363.555 198.652C362.24 197.773 361.214 196.523 360.609 195.061C360.003 193.6 359.845 191.991 360.154 190.439C360.462 188.887 361.224 187.462 362.343 186.343C363.462 185.224 364.887 184.462 366.439 184.154C367.991 183.845 369.6 184.003 371.061 184.609C372.523 185.214 373.773 186.24 374.652 187.555C375.531 188.871 376 190.418 376 192C376 194.122 375.157 196.157 373.657 197.657C372.157 199.157 370.122 200 368 200Z"
                fill="black"
              />
            </g>
            <defs>
              <filter
                id="filter0_d"
                x="-15"
                y="-15"
                width="552"
                height="552"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dx="5" dy="5" />
                <feGaussianBlur stdDeviation="10" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" className="custom-toggler"/>
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ml-auto">
          <Nav.Link as={Link} to="/">
            Home
          </Nav.Link>
          <Nav.Link as={Link} to="/search">
            Anime Search
          </Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default Navigation;
